// 通用接口
import http from '@/jslibs/axios/http';

// 登录
export const getCountryList = data => http.post('/common/api/getCountryList', data);